unit systemsetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.TMSWEBCustomComponent, WEBLib.TMSWEBStateManager,
  WEBLib.TMSWEBResponsiveManager, WEBLib.DBCtrls, WEBLib.ComCtrls;

type
  TfrmSystemSetup = class(TForm)
    XDataWebDataSet1: TXDataWebDataSet;
    WebDataSource1: TDataSource;
    WebPanel2: TPanel;
    WebLabel1: TLabel;
    WebResponsiveManager1: TResponsiveManager;
    WebPageControl1: TPageControl;
    WebPageControl1Sheet1: TTabSheet;
    WebPageControl1Sheet2: TTabSheet;
    WebPageControl1Sheet3: TTabSheet;
    WebPanel1: TPanel;
    WebLabel2: TLabel;
    WebImageControl1: TImageControl;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebDBEdit1: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebDBEdit13: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebDBEdit15: TDBEdit;
    WebDBEdit16: TDBEdit;
    WebDBEdit17: TDBEdit;
    WebDBEdit18: TDBEdit;
    WebDBEdit19: TDBEdit;
    WebDBEdit20: TDBEdit;
    WebDBEdit21: TDBEdit;
    WebPanel3: TPanel;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebDBLookupComboBox1: TDBLookupComboBox;
    WebDBLookupComboBox2: TDBLookupComboBox;
    WebDBLookupComboBox3: TDBLookupComboBox;
    WebDBLookupComboBox4: TDBLookupComboBox;
    WebDBLookupComboBox5: TDBLookupComboBox;
    WebDBLookupComboBox6: TDBLookupComboBox;
    WebPanel4: TPanel;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBEdit22: TDBEdit;
    WebDBEdit24: TDBEdit;
    WebLabel6: TLabel;
    WebDBCheckBox1: TDBCheckBox;
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmSystemSetup: TfrmSystemSetup;

implementation

{$R *.dfm}

uses
 stfmssystem.connection;

procedure TfrmSystemSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebResponsiveManager1 := TResponsiveManager.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPageControl1Sheet1 := TTabSheet.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebDBEdit16 := TDBEdit.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebDBEdit18 := TDBEdit.Create(Self);
  WebDBEdit19 := TDBEdit.Create(Self);
  WebDBEdit20 := TDBEdit.Create(Self);
  WebDBEdit21 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBLookupComboBox1 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox2 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox3 := TDBLookupComboBox.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit22 := TDBEdit.Create(Self);
  WebDBEdit24 := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebPageControl1Sheet2 := TTabSheet.Create(Self);
  WebPageControl1Sheet3 := TTabSheet.Create(Self);
  WebDBLookupComboBox4 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox5 := TDBLookupComboBox.Create(Self);
  WebDBLookupComboBox6 := TDBLookupComboBox.Create(Self);
  XDataWebDataSet1 := TXDataWebDataSet.Create(Self);
  WebDataSource1 := TDataSource.Create(Self);

  WebPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebResponsiveManager1.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPageControl1Sheet1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebDBEdit16.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebDBEdit18.BeforeLoadDFMValues;
  WebDBEdit19.BeforeLoadDFMValues;
  WebDBEdit20.BeforeLoadDFMValues;
  WebDBEdit21.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBLookupComboBox1.BeforeLoadDFMValues;
  WebDBLookupComboBox2.BeforeLoadDFMValues;
  WebDBLookupComboBox3.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit22.BeforeLoadDFMValues;
  WebDBEdit24.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebPageControl1Sheet2.BeforeLoadDFMValues;
  WebPageControl1Sheet3.BeforeLoadDFMValues;
  WebDBLookupComboBox4.BeforeLoadDFMValues;
  WebDBLookupComboBox5.BeforeLoadDFMValues;
  WebDBLookupComboBox6.BeforeLoadDFMValues;
  XDataWebDataSet1.BeforeLoadDFMValues;
  WebDataSource1.BeforeLoadDFMValues;
  try
    Name := 'frmSystemSetup';
    Width := 900;
    Height := 600;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 900;
    WebPanel2.Height := 33;
    WebPanel2.Align := alTop;
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clSilver;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 900;
    WebLabel1.Height := 15;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'System Setup';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebResponsiveManager1.SetParentComponent(Self);
    WebResponsiveManager1.Name := 'WebResponsiveManager1';
    WebResponsiveManager1.Left := 240;
    WebResponsiveManager1.Top := 288;
    WebResponsiveManager1.Width := 26;
    WebResponsiveManager1.Height := 26;
    WebResponsiveManager1.Visible := True;
    WebResponsiveManager1.ActiveState := 0;
    WebResponsiveManager1.States.Clear;
    with WebResponsiveManager1.States.Add do
    begin
      Name := 'State 1';
      Content := '{"components":[{"WebPanel1":{"content":{"$type":"TWebPanel","Align":5,"Alignment":2,"AlignWithMargins":false,"Anchors":15,"AutoSize":false,"BorderColor":"#C0C0C0","BorderStyle":1,"Caption":"","Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"ChildOrder":0,"Color":"#C0C0C0","Cursor":0,"CustomHint":"","DragMode":0,"ElementBodyClassName":"","ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":767,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebPanel1","Padding":{"$type":"TPadding","Bottom":0,"Left":0,"Right":0,"Top":0},"ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowCaption":true,"ShowHint":false,"Tag":0,"Top":33,"Visible":true,"Width":800,"WidthPercent":100,"WidthStyle":1}, "parent":"frmSystemSetup"}},{"WebLabel2":{"content":{"$type":"TWebLabel","Align":0,"Alignment":0,"AlignWithMargins":false,"Anchors":3,"AutoSize":true,"Caption":"Company Name : ","ChildOrder":0,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementLabelClassName":"","ElementPosition":0,"EllipsisPosition":0,"Enabled":true,"FocusControl":"","Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":15,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","HTML":"","HTMLType":0,"Layout":0,"Left":24,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebLabel2","ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowAccelChar":true,"ShowHint":false,"Tag":0,"TextDirection":0,"Top":16,"Transparent":true,"Visible":true,"Width":96,"WidthPercent":100,"WidthStyle":1,"WordWrap":false}, "parent":"WebPanel1"}},{"WebImageControl1":{"content":{"$type":"TWebImageControl","Align":0,"AlignWithMargins":false,"Anchors":3,"AutoSize":false,"ChildOrder":2,"Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Height":202,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":519,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebImageControl1","ParentCustomHint":true,"Picture":"","PopupMenu":"","Role":"","ShowHint":false,"Tag":0,"Top":31,"URL":"","Visible":true,"Width":473,"WidthPercent":100,"WidthStyle":1}, "parent":"WebPanel1"}},{"WebDBEdit1":{"content":{"$type":"TWebDBEdit","Align":0,"Alignment":0,"AlignWithMargins":false,"Anchors":3,"AutoCompletion":0,"AutoFocus":false,"AutoSelect":true,"AutoSize":false,"BiDiMode":0,"BorderStyle":1,"Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"CharCase":1,"ChildOrder":2,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DataField":"","DataSource":"","DragMode":0,"EditType":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":22,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"HideSelection":true,"Hint":"","Left":126,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"MaxLength":0,"Name":"WebDBEdit1","ParentCustomHint":true,"ParentFont":true,"PasswordChar":"","Pattern":"","PopupMenu":"","ReadOnly":false,"Required":false,"RequiredText":"","Role":"","ShowFocus":true,"ShowHint":false,"SpellCheck":true,"TabOrder":0,"TabStop":true,"Tag":0,"Text":"WebDBEdit1","TextDirection":0,"TextHint":"","Top":13,"Visible":true,"Width":387,"WidthPercent":100,"WidthStyle":1}, "parent":"WebPanel1"}},{"WebPanel2":{"content":{"$type":"TWebPanel","Align":1,"Alignment":2,"AlignWithMargins":false,"Anchors":7,"AutoSize":false,"BorderColor":"#C0C0C0","BorderStyle":1,"Caption":"","Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"ChildOrder":1,"Color":"#C0C0C0","Cursor":0,"CustomHint":"","DragMode":0,"ElementBodyClassName":"","ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":33,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebPanel2","Padding":{"$type":"TPadding","Bottom":0,"Left":0,"Right":0,"Top":0},"ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowCaption":true,"ShowHint":false,"Tag":0,"Top":0,"Visible":true,"Width":800,"WidthPercent":100,"WidthStyle":1}, "parent":"frmSystemSetup"}},{"WebLabel1":{"content":{"$type":"TWebLabel","Align":1,"Alignment":2,"AlignWithMargins":false,"Anchors":7,"AutoSize":true,"Caption":"System Setup","ChildOrder":0,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementLabelClassName":"","ElementPosition":0,"EllipsisPosition":0,"Enabled":true,"FocusControl":"","Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":15,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","HTML":"","HTMLType":0,"Layout":0,"Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebLabel1","ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowAccelChar":true,"ShowHint":false,"Tag":0,"TextDirection":0,"Top":0,"Transparent":true,"Visible":true,"Width":800,"WidthPercent":100,"WidthStyle":1,"WordWrap":false}, "parent":"WebPanel2"}}]}';
      Default := True;
      Constraint.Width := 900.000000000000000000;
      Constraint.Height := 600.000000000000000000;
    end;
    with WebResponsiveManager1.States.Add do
    begin
      Name := 'State 2';
      Content := '{"components":[{"WebPanel1":{"content":{"$type":"TWebPanel","Align":5,"Alignment":2,"AlignWithMargins":false,"Anchors":15,"AutoSize":false,"BorderColor":"#C0C0C0","BorderStyle":1,"Caption":"","Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"ChildOrder":0,"Color":"#C0C0C0","Cursor":0,"CustomHint":"","DragMode":0,"ElementBodyClassName":"","ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":447,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebPanel1","Padding":{"$type":"TPadding","Bottom":0,"Left":0,"Right":0,"Top":0},"ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowCaption":true,"ShowHint":false,"Tag":0,"Top":33,"Visible":true,"Width":640,"WidthPercent":100,"WidthStyle":1}, "parent":"frmSystemSetup"}},{"WebLabel2":{"content":{"$type":"TWebLabel","Align":0,"Alignment":0,"AlignWithMargins":false,"Anchors":3,"AutoSize":true,"Caption":"Company Name : ","ChildOrder":0,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementLabelClassName":"","ElementPosition":0,"EllipsisPosition":0,"Enabled":true,"FocusControl":"","Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":15,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","HTML":"","HTMLType":0,"Layout":0,"Left":24,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebLabel2","ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowAccelChar":true,"ShowHint":false,"Tag":0,"TextDirection":0,"Top":16,"Transparent":true,"Visible":true,"Width":96,"WidthPercent":100,"WidthStyle":1,"WordWrap":false}, "parent":"WebPanel1"}},{"WebImageControl1":{"content":{"$type":"TWebImageControl","Align":0,"AlignWithMargins":false,"Anchors":3,"AutoSize":false,"ChildOrder":2,"Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Height":202,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":792,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebImageControl1","ParentCustomHint":true,"Picture":"","PopupMenu":"","Role":"","ShowHint":false,"Tag":0,"Top":16,"URL":"","Visible":true,"Width":473,"WidthPercent":100,"WidthStyle":1}, "parent":"WebPanel1"}},{"WebDBEdit1":{"content":{"$type":"TWebDBEdit","Align":0,"Alignment":0,"AlignWithMargins":false,"Anchors":3,"AutoCompletion":0,"AutoFocus":false,"AutoSelect":true,"AutoSize":false,"BiDiMode":0,"BorderStyle":1,"Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"CharCase":1,"ChildOrder":2,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DataField":"","DataSource":"","DragMode":0,"EditType":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":22,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"HideSelection":true,"Hint":"","Left":126,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"MaxLength":0,"Name":"WebDBEdit1","ParentCustomHint":true,"ParentFont":true,"PasswordChar":"","Pattern":"","PopupMenu":"","ReadOnly":false,"Required":false,"RequiredText":"","Role":"","ShowFocus":true,"ShowHint":false,"SpellCheck":true,"TabOrder":0,"TabStop":true,"Tag":0,"Text":"WebDBEdit1","TextDirection":0,"TextHint":"","Top":13,"Visible":true,"Width":121,"WidthPercent":100,"WidthStyle":1}, "parent":"WebPanel1"}},{"WebPanel2":{"content":{"$type":"TWebPanel","Align":1,"Alignment":2,"AlignWithMargins":false,"Anchors":7,"AutoSize":false,"BorderColor":"#C0C0C0","BorderStyle":1,"Caption":"","Center":{"$type":"TCenter","Horizontal":false,"Vertical":false},"ChildOrder":1,"Color":"#C0C0C0","Cursor":0,"CustomHint":"","DragMode":0,"ElementBodyClassName":"","ElementClassName":"","ElementFont":0,"ElementID":"","ElementPosition":0,"Enabled":true,"Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":33,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebPanel2","Padding":{"$type":"TPadding","Bottom":0,"Left":0,"Right":0,"Top":0},"ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowCaption":true,"ShowHint":false,"Tag":0,"Top":0,"Visible":true,"Width":640,"WidthPercent":100,"WidthStyle":1}, "parent":"frmSystemSetup"}},{"WebLabel1":{"content":{"$type":"TWebLabel","Align":1,"Alignment":2,"AlignWithMargins":false,"Anchors":7,"AutoSize":true,"Caption":"System Setup","ChildOrder":0,"Color":"#FFFFFF","Cursor":0,"CustomHint":"","DragMode":0,"ElementClassName":"","ElementFont":0,"ElementID":"","ElementLabelClassName":"","ElementPosition":0,"EllipsisPosition":0,"Enabled":true,"FocusControl":"","Font":{"$type":"TFont","Charset":1,"Color":"#000000","Height":-12,"Name":"Segoe UI","Orientation":0,"Pitch":0,"Quality":0,"Size":9,"IsFMX":false,"Style":0},"Height":15,"HeightPercent":100,"HeightStyle":1,"HelpContext":0,"HelpKeyword":"","HelpType":1,"Hint":"","HTML":"","HTMLType":0,"Layout":0,"Left":0,"Margins":{"$type":"TMargins","Bottom":3,"Left":3,"Right":3,"Top":3},"Name":"WebLabel1","ParentCustomHint":true,"ParentFont":true,"PopupMenu":"","Role":"","ShowAccelChar":true,"ShowHint":false,"Tag":0,"TextDirection":0,"Top":0,"Transparent":true,"Visible":true,"Width":640,"WidthPercent":100,"WidthStyle":1,"WordWrap":false}, "parent":"WebPanel2"}}]}';
      Constraint.Width := 640.000000000000000000;
      Constraint.Height := 480.000000000000000000;
    end;
    WebResponsiveManager1.Control := Self;
    WebPageControl1.SetParentComponent(Self);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 33;
    WebPageControl1.Width := 900;
    WebPageControl1.Height := 567;
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 3;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.TabOrder := 2;
    WebPageControl1Sheet1.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet1.Name := 'WebPageControl1Sheet1';
    WebPageControl1Sheet1.Left := 0;
    WebPageControl1Sheet1.Top := 20;
    WebPageControl1Sheet1.Width := 900;
    WebPageControl1Sheet1.Height := 547;
    WebPageControl1Sheet1.Align := alClient;
    WebPageControl1Sheet1.Caption := 'Company Information';
    WebPanel1.SetParentComponent(WebPageControl1Sheet1);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 900;
    WebPanel1.Height := 478;
    WebPanel1.Align := alClient;
    WebPanel1.Color := clSilver;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 24;
    WebLabel2.Top := 16;
    WebLabel2.Width := 96;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Company Name : ';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebImageControl1.SetParentComponent(WebPanel1);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 536;
    WebImageControl1.Top := 6;
    WebImageControl1.Width := 337;
    WebImageControl1.Height := 187;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.ChildOrder := 2;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 24;
    WebLabel3.Top := 41;
    WebLabel3.Width := 99;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Company Adress : ';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 320;
    WebLabel4.Top := 41;
    WebLabel4.Width := 79;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Postal Adress : ';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 126;
    WebDBEdit1.Top := 13;
    WebDBEdit1.Width := 387;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.Color := clWhite;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit12.SetParentComponent(WebPanel1);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 24;
    WebDBEdit12.Top := 61;
    WebDBEdit12.Width := 192;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 4;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit2';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit13.SetParentComponent(WebPanel1);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 24;
    WebDBEdit13.Top := 86;
    WebDBEdit13.Width := 192;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 5;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit3';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit14.SetParentComponent(WebPanel1);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 24;
    WebDBEdit14.Top := 111;
    WebDBEdit14.Width := 192;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 6;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit4';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit15.SetParentComponent(WebPanel1);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 24;
    WebDBEdit15.Top := 136;
    WebDBEdit15.Width := 192;
    WebDBEdit15.Height := 22;
    WebDBEdit15.ChildOrder := 7;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.Text := 'WebDBEdit5';
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit16.SetParentComponent(WebPanel1);
    WebDBEdit16.Name := 'WebDBEdit16';
    WebDBEdit16.Left := 24;
    WebDBEdit16.Top := 161;
    WebDBEdit16.Width := 86;
    WebDBEdit16.Height := 22;
    WebDBEdit16.ChildOrder := 8;
    WebDBEdit16.HeightPercent := 100.000000000000000000;
    WebDBEdit16.Text := 'WebDBEdit6';
    WebDBEdit16.WidthPercent := 100.000000000000000000;
    WebDBEdit17.SetParentComponent(WebPanel1);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 320;
    WebDBEdit17.Top := 161;
    WebDBEdit17.Width := 86;
    WebDBEdit17.Height := 22;
    WebDBEdit17.ChildOrder := 8;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.Text := 'WebDBEdit6';
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebDBEdit18.SetParentComponent(WebPanel1);
    WebDBEdit18.Name := 'WebDBEdit18';
    WebDBEdit18.Left := 320;
    WebDBEdit18.Top := 136;
    WebDBEdit18.Width := 192;
    WebDBEdit18.Height := 22;
    WebDBEdit18.ChildOrder := 7;
    WebDBEdit18.HeightPercent := 100.000000000000000000;
    WebDBEdit18.Text := 'WebDBEdit5';
    WebDBEdit18.WidthPercent := 100.000000000000000000;
    WebDBEdit19.SetParentComponent(WebPanel1);
    WebDBEdit19.Name := 'WebDBEdit19';
    WebDBEdit19.Left := 320;
    WebDBEdit19.Top := 111;
    WebDBEdit19.Width := 192;
    WebDBEdit19.Height := 22;
    WebDBEdit19.ChildOrder := 6;
    WebDBEdit19.HeightPercent := 100.000000000000000000;
    WebDBEdit19.Text := 'WebDBEdit4';
    WebDBEdit19.WidthPercent := 100.000000000000000000;
    WebDBEdit20.SetParentComponent(WebPanel1);
    WebDBEdit20.Name := 'WebDBEdit20';
    WebDBEdit20.Left := 320;
    WebDBEdit20.Top := 86;
    WebDBEdit20.Width := 192;
    WebDBEdit20.Height := 22;
    WebDBEdit20.ChildOrder := 5;
    WebDBEdit20.HeightPercent := 100.000000000000000000;
    WebDBEdit20.Text := 'WebDBEdit3';
    WebDBEdit20.WidthPercent := 100.000000000000000000;
    WebDBEdit21.SetParentComponent(WebPanel1);
    WebDBEdit21.Name := 'WebDBEdit21';
    WebDBEdit21.Left := 320;
    WebDBEdit21.Top := 61;
    WebDBEdit21.Width := 192;
    WebDBEdit21.Height := 22;
    WebDBEdit21.ChildOrder := 4;
    WebDBEdit21.HeightPercent := 100.000000000000000000;
    WebDBEdit21.Text := 'WebDBEdit2';
    WebDBEdit21.WidthPercent := 100.000000000000000000;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 24;
    WebDBEdit2.Top := 224;
    WebDBEdit2.Width := 162;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 15;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit3.SetParentComponent(WebPanel1);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 202;
    WebDBEdit3.Top := 224;
    WebDBEdit3.Width := 162;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 15;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit2';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit4.SetParentComponent(WebPanel1);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 392;
    WebDBEdit4.Top := 224;
    WebDBEdit4.Width := 162;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 15;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit2';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit5.SetParentComponent(WebPanel1);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 24;
    WebDBEdit5.Top := 272;
    WebDBEdit5.Width := 162;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 15;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit2';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit6.SetParentComponent(WebPanel1);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 202;
    WebDBEdit6.Top := 272;
    WebDBEdit6.Width := 162;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 15;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit2';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit7.SetParentComponent(WebPanel1);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 392;
    WebDBEdit7.Top := 272;
    WebDBEdit7.Width := 162;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 15;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit2';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit8.SetParentComponent(WebPanel1);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 24;
    WebDBEdit8.Top := 320;
    WebDBEdit8.Width := 162;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 15;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit2';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit9.SetParentComponent(WebPanel1);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 202;
    WebDBEdit9.Top := 320;
    WebDBEdit9.Width := 162;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 15;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit2';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox1.SetParentComponent(WebPanel1);
    WebDBLookupComboBox1.Name := 'WebDBLookupComboBox1';
    WebDBLookupComboBox1.Left := 261;
    WebDBLookupComboBox1.Top := 392;
    WebDBLookupComboBox1.Width := 145;
    WebDBLookupComboBox1.Height := 22;
    WebDBLookupComboBox1.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox1.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox2.SetParentComponent(WebPanel1);
    WebDBLookupComboBox2.Name := 'WebDBLookupComboBox2';
    WebDBLookupComboBox2.Left := 24;
    WebDBLookupComboBox2.Top := 392;
    WebDBLookupComboBox2.Width := 209;
    WebDBLookupComboBox2.Height := 22;
    WebDBLookupComboBox2.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox2.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox3.SetParentComponent(WebPanel1);
    WebDBLookupComboBox3.Name := 'WebDBLookupComboBox3';
    WebDBLookupComboBox3.Left := 24;
    WebDBLookupComboBox3.Top := 440;
    WebDBLookupComboBox3.Width := 209;
    WebDBLookupComboBox3.Height := 22;
    WebDBLookupComboBox3.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox3.WidthPercent := 100.000000000000000000;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 599;
    WebPanel4.Top := 208;
    WebPanel4.Width := 274;
    WebPanel4.Height := 169;
    WebPanel4.BorderStyle := bsNone;
    WebPanel4.ChildOrder := 32;
    WebPanel4.Color := clSilver;
    WebLabel6.SetParentComponent(WebPanel4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 26;
    WebLabel6.Top := 17;
    WebLabel6.Width := 58;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'WebLabel5';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBEdit10.SetParentComponent(WebPanel4);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 23;
    WebDBEdit10.Top := 42;
    WebDBEdit10.Width := 221;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 23;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit10';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit11.SetParentComponent(WebPanel4);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 23;
    WebDBEdit11.Top := 68;
    WebDBEdit11.Width := 221;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 24;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit11';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit22.SetParentComponent(WebPanel4);
    WebDBEdit22.Name := 'WebDBEdit22';
    WebDBEdit22.Left := 23;
    WebDBEdit22.Top := 94;
    WebDBEdit22.Width := 221;
    WebDBEdit22.Height := 22;
    WebDBEdit22.ChildOrder := 25;
    WebDBEdit22.HeightPercent := 100.000000000000000000;
    WebDBEdit22.Text := 'WebDBEdit22';
    WebDBEdit22.WidthPercent := 100.000000000000000000;
    WebDBEdit24.SetParentComponent(WebPanel4);
    WebDBEdit24.Name := 'WebDBEdit24';
    WebDBEdit24.Left := 23;
    WebDBEdit24.Top := 119;
    WebDBEdit24.Width := 221;
    WebDBEdit24.Height := 22;
    WebDBEdit24.ChildOrder := 27;
    WebDBEdit24.HeightPercent := 100.000000000000000000;
    WebDBEdit24.Text := 'WebDBEdit24';
    WebDBEdit24.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.SetParentComponent(WebPanel4);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 131;
    WebDBCheckBox1.Top := 14;
    WebDBCheckBox1.Width := 113;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := 'WebDBCheckBox1';
    WebDBCheckBox1.ChildOrder := 30;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebPanel3.SetParentComponent(WebPageControl1Sheet1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 478;
    WebPanel3.Width := 900;
    WebPanel3.Height := 69;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPageControl1Sheet2.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet2.Name := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.Left := 0;
    WebPageControl1Sheet2.Top := 20;
    WebPageControl1Sheet2.Width := 900;
    WebPageControl1Sheet2.Height := 547;
    WebPageControl1Sheet2.Caption := 'WebPageControl1Sheet2';
    WebPageControl1Sheet2.ChildOrder := 1;
    WebPageControl1Sheet3.SetParentComponent(WebPageControl1);
    WebPageControl1Sheet3.Name := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.Left := 0;
    WebPageControl1Sheet3.Top := 20;
    WebPageControl1Sheet3.Width := 900;
    WebPageControl1Sheet3.Height := 547;
    WebPageControl1Sheet3.Caption := 'WebPageControl1Sheet3';
    WebPageControl1Sheet3.ChildOrder := 2;
    WebDBLookupComboBox4.SetParentComponent(Self);
    WebDBLookupComboBox4.Name := 'WebDBLookupComboBox4';
    WebDBLookupComboBox4.Left := 261;
    WebDBLookupComboBox4.Top := 493;
    WebDBLookupComboBox4.Width := 145;
    WebDBLookupComboBox4.Height := 22;
    WebDBLookupComboBox4.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox4.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox5.SetParentComponent(Self);
    WebDBLookupComboBox5.Name := 'WebDBLookupComboBox5';
    WebDBLookupComboBox5.Left := 376;
    WebDBLookupComboBox5.Top := 389;
    WebDBLookupComboBox5.Width := 145;
    WebDBLookupComboBox5.Height := 22;
    WebDBLookupComboBox5.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox5.WidthPercent := 100.000000000000000000;
    WebDBLookupComboBox6.SetParentComponent(Self);
    WebDBLookupComboBox6.Name := 'WebDBLookupComboBox6';
    WebDBLookupComboBox6.Left := 392;
    WebDBLookupComboBox6.Top := 465;
    WebDBLookupComboBox6.Width := 145;
    WebDBLookupComboBox6.Height := 22;
    WebDBLookupComboBox6.HeightPercent := 100.000000000000000000;
    WebDBLookupComboBox6.WidthPercent := 100.000000000000000000;
    XDataWebDataSet1.SetParentComponent(Self);
    XDataWebDataSet1.Name := 'XDataWebDataSet1';
    XDataWebDataSet1.Connection := dmData.dbConnect;
    XDataWebDataSet1.Left := 200;
    XDataWebDataSet1.Top := 120;
    WebDataSource1.SetParentComponent(Self);
    WebDataSource1.Name := 'WebDataSource1';
    WebDataSource1.DataSet := XDataWebDataSet1;
    WebDataSource1.Left := 352;
    WebDataSource1.Top := 184;
  finally
    WebPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebResponsiveManager1.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPageControl1Sheet1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebDBEdit16.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebDBEdit18.AfterLoadDFMValues;
    WebDBEdit19.AfterLoadDFMValues;
    WebDBEdit20.AfterLoadDFMValues;
    WebDBEdit21.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBLookupComboBox1.AfterLoadDFMValues;
    WebDBLookupComboBox2.AfterLoadDFMValues;
    WebDBLookupComboBox3.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit22.AfterLoadDFMValues;
    WebDBEdit24.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebPageControl1Sheet2.AfterLoadDFMValues;
    WebPageControl1Sheet3.AfterLoadDFMValues;
    WebDBLookupComboBox4.AfterLoadDFMValues;
    WebDBLookupComboBox5.AfterLoadDFMValues;
    WebDBLookupComboBox6.AfterLoadDFMValues;
    XDataWebDataSet1.AfterLoadDFMValues;
    WebDataSource1.AfterLoadDFMValues;
  end;
end;

end.
